import { useState } from "react";
import { faqs } from "@/mocks/fun";
import Reveal from "@/components/base/Reveal";

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[900px] px-4 md:px-6">
        <Reveal>
          <div className="mx-auto max-w-2xl text-center">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1.5 text-xs font-semibold text-secondary-900">
              <i className="ri-question-line"></i> 常见问题
            </span>
            <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">关于吃瓜，你可能想问</h2>
            <p className="mt-2 text-sm text-foreground-600 md:text-base">答疑完毕，笑点就位，请放心开吃。</p>
          </div>
        </Reveal>

        <Reveal>
          <div className="mt-8 flex flex-col gap-3">
            {faqs.map((f, i) => {
              const isOpen = open === i;
              return (
                <div
                  key={i}
                  className={`overflow-hidden rounded-2xl border transition-colors ${
                    isOpen ? "border-primary-200 bg-background-100" : "border-background-200 bg-background-50"
                  }`}
                >
                  <button
                    onClick={() => setOpen(isOpen ? null : i)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center gap-3 px-5 py-4 text-left"
                  >
                    <span
                      className={`grid h-8 w-8 shrink-0 place-items-center rounded-full ${
                        isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                      }`}
                    >
                      {isOpen ? <i className="ri-subtract-line"></i> : <i className="ri-add-line"></i>}
                    </span>
                    <h3 className="flex-1 text-[15px] font-semibold text-foreground-900 md:text-base">{f.q}</h3>
                  </button>
                  {isOpen && (
                    <div className="px-5 pb-5 pl-16 text-sm leading-relaxed text-foreground-600 md:text-[15px]">
                      {f.a}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </Reveal>
      </div>
    </section>
  );
}